import { Grid } from '@mui/material';
import { FormFieldRowElementProps } from '../../../../../../types/form';
import FormFieldDefaultSelect from './FormFieldDefaultSelect';
import FormFieldOptions from './FormFieldOptions';

export default function FormFieldRowRadio({
  formField,
  index,
}: FormFieldRowElementProps) {
  return (
    <Grid container spacing={2} mt={1}>
      <Grid item xs={12}>
        <FormFieldOptions index={index} />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormFieldDefaultSelect
          value={formField.default ? String(formField.default) : ''}
          index={index}
          options={formField.options}
        />
      </Grid>
    </Grid>
  );
}
